module.exports = __webpack_public_path__ + "static/media/kid21.7a38384a.png";